export const COMPOUND_ID_DELIMITER = ':';
